import applyPieveProjectOptimisticMutation from '@/redux/reducers/pieveReducer/applyPieveProjectOptimisticMutation.js';

const buildVisibleProjectsFromPendingMutations = ({ serverProjects, pendingMutations } = {}) => {
  const baseProjects = Array.isArray(serverProjects) ? serverProjects : [];
  const optimisticMutations = Array.isArray(pendingMutations) ? pendingMutations : [];

  return optimisticMutations.reduce((currentProjects, pendingMutation) => {
    const nextState = applyPieveProjectOptimisticMutation({
      state: { projects: currentProjects },
      payload: pendingMutation?.payload,
      mutation: pendingMutation?.mutation
    });

    return Array.isArray(nextState?.projects) ? nextState.projects : currentProjects;
  }, baseProjects);
};

export default buildVisibleProjectsFromPendingMutations;
